export default Object.freeze({
  TABLE_ITEMS: 30,
  SEARCH_ITEMS: 100,
});
